import React from "react";
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

import TextInputField from "../textInputField/textInputField";
import InputDropdown from "../inputDropdown/inputDropdown";
import "./popoverFilter.css";


const PopoverFilter = ({title, filterList, formControl, inputKey, placeholder, onChange, defaultValue="", filterType="dropdown"}) => {
    const popover = (
        <Popover id="popover-basic" style={{width: "500px"}}>
            <Popover.Header as="h3">{title}</Popover.Header>
            <Popover.Body>
                {
                    filterType === "dropdown"
                        ?
                        <InputDropdown
                            inputKey={inputKey}
                            formRegister={formControl}
                            itemList={filterList}
                            maxWidth="400px"
                            placeholder={placeholder}
                            defaultValue={defaultValue}
                            onDropdownChange={onChange}
                        />
                        :
                        filterType === "date"
                            ?
                            <TextInputField
                                placeholder={placeholder}
                                fieldType="date"
                                inputKey={inputKey}
                                formRegister={formControl}
                                maxWidth="400px"
                                onChange={onChange}
                            />
                            :
                            <></>
                }
                
            </Popover.Body>
        </Popover>
    )

    return (
        <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
            <button className="icon-button-button">
                <i className={"bi icon-button-icon bi-funnel-fill"}></i>
            </button>
        </OverlayTrigger>
    );
    
}
export default PopoverFilter;
